export const reservationLink =
    'https://wynajmij.comfortstorage.eu/location/91a88543-cfac-ef11-88d0-000d3a145b56';
export const rentLink = 'https://wynajmij.comfortstorage.eu/login';
